require.register("modules/m03/m03-activity/page-14_il_cc/page-14_il_cc", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page14_il_cc = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page14_il_cc;

  
});

